/**
 * Formats phone numbers with country-specific patterns
 * @param {string} phone - Raw phone number input
 * @returns {string} Formatted phone number
 */
export default function formatPhoneNumber(phone) {
  if (!phone || typeof phone !== 'string') return '';
  
  const numeric = phone.replace(/\D/g, '');
  if (!numeric) return phone;
  
  // Country code patterns (top 8 by population + common formats)
  const patterns = [
    { code: '1', len: 11, template: (n) => `+1 ${n.slice(1,4)}-${n.slice(4,7)}-${n.slice(7)}` }, // US/Canada
    { code: '86', len: 13, template: (n) => `+86 ${n.slice(2,5)} ${n.slice(5,9)} ${n.slice(9)}` }, // China
    { code: '91', len: 12, template: (n) => `+91 ${n.slice(2,5)} ${n.slice(5,7)} ${n.slice(7)}` }, // India
    { code: '62', len: 11, template: (n) => `+62 ${n.slice(2,5)}-${n.slice(5,9)}-${n.slice(9)}` }, // Indonesia
    { code: '92', len: 12, template: (n) => `+92 ${n.slice(2,5)}-${n.slice(5,8)}-${n.slice(8)}` }, // Pakistan
    { code: '55', len: 12, template: (n) => `+55 ${n.slice(2,4)} ${n.slice(4,8)}-${n.slice(8)}` }, // Brazil
    { code: '234', len: 13, template: (n) => `+234 ${n.slice(3,6)}-${n.slice(6,9)}-${n.slice(9)}` }, // Nigeria
    { code: '81', len: 11, template: (n) => `+81 ${n.slice(2,5)}-${n.slice(5,8)}-${n.slice(8)}` }, // Japan
    { code: '44', len: 12, template: (n) => `+44 ${n.slice(2,5)}-${n.slice(5,8)}-${n.slice(8)}` }, // UK
  ];

  // Try country-specific patterns first
  for (const {code, len, template} of patterns) {
    if (numeric.startsWith(code) && numeric.length === len) {
      return template(numeric);
    }
  }

  // Generic international format (country code + space + groups of 3-4 digits)
  if (numeric.length > 7) {
    const countryCode = numeric.length > 10 ? `+${numeric.slice(0, numeric.length-10)} ` : '';
    const mainNumber = numeric.slice(-10);
    return `${countryCode}${mainNumber.slice(0, 3)}-${mainNumber.slice(3, 6)}-${mainNumber.slice(6)}`;
  }

  // Local format (no country code)
  if (numeric.length === 10) {
    return `${numeric.slice(0, 3)}-${numeric.slice(3, 6)}-${numeric.slice(6)}`;
  }

  return phone; // Return original if no pattern matches
}